/* Optional analytics. Strict opt-in, no buyer PII, no tracking scripts before consent. */
(() => {
  'use strict';
  if (window.DFAnalytics) return;
  const node = document.getElementById('df-analytics-config');
  if (!node) return;
  let config;
  try { config = JSON.parse(node.textContent); } catch (_) { return; }
  const gaId = /^G-[A-Z0-9]+$/.test(config.ga4 || '') ? config.ga4 : '';
  const metaId = /^\d{5,20}$/.test(config.meta || '') ? config.meta : '';
  const isShopify = config.platform === 'shopify';
  const privatePage = /\/(?:d|library)(?:\/|$)/i.test(location.pathname);
  const secretQuery = [...new URLSearchParams(location.search).keys()].some(name => /^_?(?:(?:[a-z0-9]+_)*(?:key|token|nonce)|wpnonce)$/i.test(name));
  const sensitivePage = config.sensitivePage === true || secretQuery || privatePage;
  const storageKey = 'df-consent-v1';
  const expiry = 180 * 86400 * 1000;
  let state = { analytics: false, marketing: false };
  let initialized = { ga: false, meta: false };
  let ready = !isShopify;
  let chosen = false;
  const sent = new Set();
  const banner = document.querySelector('[data-df-consent]');
  const safeUrl = value => { try { const u = new URL(value); return u.origin + (/\/(?:d|library)(?:\/|$)/i.test(u.pathname) ? '/private-download/' : u.pathname); } catch (_) { return ''; } };
  const read = key => { try { return JSON.parse(localStorage.getItem(key)); } catch (_) { return null; } };
  const write = (key, value) => { try { localStorage.setItem(key, JSON.stringify(value)); } catch (_) { /* ephemeral consent */ } };
  const load = (id, src) => {
    if (document.getElementById(id)) return;
    const script = document.createElement('script');
    script.id = id; script.async = true; script.src = src; script.referrerPolicy = 'no-referrer';
    document.head.appendChild(script);
  };
  window.dataLayer = window.dataLayer || [];
  const gtag = (...args) => window.dataLayer.push(args);
  // Basic consent mode: no cookieless pings before consent because no Google script exists yet.
  gtag('consent', 'default', { analytics_storage: 'denied', ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied' });
  function clearNativeAttributionCookies() {
    if (config.platform !== 'woocommerce' || config.nativeAttributionDisabled !== true) return;
    // Native Woo attribution is disabled independently of provider consent. Remove
    // legacy Sourcebuster cookies too; never touch Woo cart/session cookies.
    const names = new Set(['sbjs_current', 'sbjs_current_add', 'sbjs_first', 'sbjs_first_add',
      'sbjs_session', 'sbjs_udata', 'sbjs_migrations', 'sbjs_promo']);
    (document.cookie || '').split(';').forEach(cookie => {
      const name = cookie.split('=', 1)[0].trim();
      if (/^sbjs_[a-z0-9_]+$/i.test(name)) names.add(name);
    });
    const paths = new Set(['/']);
    const segments = location.pathname.split('/').filter(Boolean);
    for (let index = 1; index <= segments.length; index++) {
      const path = '/' + segments.slice(0, index).join('/');
      paths.add(path); paths.add(path + '/');
    }
    const domains = new Set(['']);
    const host = location.hostname;
    if (host && !host.includes(':')) {
      domains.add(host); domains.add('.' + host);
      if (!/^\d+(?:\.\d+){3}$/.test(host)) {
        const labels = host.split('.');
        for (let index = 1; index < labels.length - 1; index++) {
          const parent = labels.slice(index).join('.');
          domains.add(parent); domains.add('.' + parent);
        }
      }
    }
    names.forEach(name => paths.forEach(path => domains.forEach(domain => {
      document.cookie = name + '=; Path=' + path + '; Max-Age=0; Expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Lax' + (domain ? '; Domain=' + domain : '');
    })));
  }
  function configure() {
    clearNativeAttributionCookies();
    const browserAnalytics = state.analytics && !sensitivePage;
    const browserMarketing = state.marketing && !sensitivePage;
    window['ga-disable-' + gaId] = !browserAnalytics;
    gtag('consent', 'update', { analytics_storage: browserAnalytics ? 'granted' : 'denied',
      ad_storage: browserMarketing ? 'granted' : 'denied', ad_user_data: browserMarketing ? 'granted' : 'denied',
      ad_personalization: browserMarketing ? 'granted' : 'denied' });
    if (state.analytics && gaId && !sensitivePage && !initialized.ga) {
      initialized.ga = true;
      gtag('js', new Date());
      gtag('config', gaId, { send_page_view: false, allow_google_signals: false, allow_ad_personalization_signals: false,
        page_location: safeUrl(location.href), page_referrer: safeUrl(document.referrer) });
      load('df-ga4-script', 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(gaId));
    }
    captureGoogleClient();
    // Provider auto-measurement can read full form/link URLs. No provider may
    // load on an order-key, nonce, token or private download page.
    if (state.marketing && metaId && !sensitivePage && !initialized.meta) {
      initialized.meta = true;
      if (!window.fbq) {
        const fbq = function () { fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments); };
        fbq.queue = []; fbq.loaded = true; fbq.version = '2.0'; window.fbq = fbq; window._fbq = fbq;
      }
      window.fbq('consent', 'grant');
      window.fbq('set', 'autoConfig', false, metaId);
      window.fbq('init', metaId);
      load('df-meta-script', 'https://connect.facebook.net/en_US/fbevents.js');
    }
    if (window.fbq) window.fbq('consent', browserMarketing ? 'grant' : 'revoke');
  }
  function clean(data = {}) {
    const safe = {};
    if (/^[A-Z]{3}$/.test(data.currency || '')) safe.currency = data.currency;
    if (typeof data.value === 'number' && Number.isFinite(data.value) && data.value >= 0) safe.value = data.value;
    if (data.transaction_id) safe.transaction_id = String(data.transaction_id).slice(0, 80);
    if (Array.isArray(data.items)) safe.items = data.items.slice(0, 100).map(item => ({
      item_id: String(item.item_id || '').slice(0, 80),
      item_name: String(item.item_name || '').slice(0, 200),
      quantity: Math.min(999, Math.max(1, Number(item.quantity) || 1)),
      ...(typeof item.price === 'number' && Number.isFinite(item.price) && item.price >= 0 ? { price: item.price } : {})
    }));
    return safe;
  }
  function track(name, data = {}, id) {
    if (sensitivePage) return;
    if (!['page_view', 'view_item', 'add_to_cart', 'remove_from_cart', 'begin_checkout', 'purchase', 'refund'].includes(name)) return;
    const eventId = id || (window.crypto?.randomUUID?.() || ('df-' + Date.now() + '-' + Math.random().toString(16).slice(2)));
    const safe = clean(data);
    const stable = name + ':' + eventId;
    let delivered = false;
    if (state.analytics && gaId && !sent.has('ga:' + stable)) {
      const persisted = name === 'purchase' && read('df-ga-purchase:' + eventId);
      if (!persisted) {
        gtag('event', name, { ...safe, event_id: eventId, page_location: safeUrl(location.href), page_referrer: safeUrl(document.referrer) });
        if (name === 'purchase') write('df-ga-purchase:' + eventId, true);
      }
      sent.add('ga:' + stable); delivered = true;
    }
    const metaEvents = { page_view: 'PageView', view_item: 'ViewContent', add_to_cart: 'AddToCart', begin_checkout: 'InitiateCheckout', purchase: 'Purchase' };
    if (state.marketing && metaId && !sensitivePage && window.fbq && metaEvents[name] && !sent.has('meta:' + stable)) {
      if (!(name === 'purchase' && read('df-meta-purchase:' + eventId))) {
        window.fbq('track', metaEvents[name], { currency: safe.currency, value: safe.value,
          content_type: 'product', content_ids: (safe.items || []).map(i => i.item_id) }, { eventID: eventId });
        if (name === 'purchase') write('df-meta-purchase:' + eventId, true);
      }
      sent.add('meta:' + stable); delivered = true;
    }
    // No pre-consent event queue: events that happened before a choice are discarded.
    if (delivered) document.dispatchEvent(new CustomEvent('df:analytics-event', { detail: { name, event_id: eventId, ...safe } }));
  }
  function show(open) { if (banner) banner.hidden = !open; }
  function initialEvents() {
    track('page_view', {}, 'page:' + location.pathname);
    (config.events || []).forEach(e => track(e.name, e.data, e.id));
  }
  function syncShopify() {
    const api = window.Shopify?.customerPrivacy;
    if (!api) return;
    const current = api.currentVisitorConsent();
    ready = true;
    chosen = current.analytics !== '' && current.marketing !== '';
    state = { analytics: current.analytics === 'yes' && api.analyticsProcessingAllowed(),
      marketing: current.marketing === 'yes' && api.marketingAllowed() && api.saleOfDataAllowed() };
    configure(); initialEvents();
    show(!chosen && Boolean(gaId || metaId));
  }
  let consentQueue = Promise.resolve();
  const serverPendingKey = 'df-server-consent-pending-v1';
  let pendingMemory = null;
  let choiceVersion = 0;
  let pendingCounter = 0;
  let retryInFlight = false;
  function pendingDenial() {
    const pending = read(serverPendingKey) || pendingMemory;
    return pending && typeof pending.id === 'string' && typeof pending.analytics === 'boolean' && typeof pending.marketing === 'boolean'
      && (!pending.analytics || !pending.marketing) && pending.saved > Date.now() - expiry ? pending : null;
  }
  function clearPending(id) {
    if (!id || pendingDenial()?.id === id) { pendingMemory = null; write(serverPendingKey, null); }
  }
  function serverStatus(message) {
    const status = banner?.querySelector('[data-df-consent-status]');
    if (status) status.textContent = message;
  }
  function persistServerConsent(explicit = false, clientId = '') {
    const endpoint = config.serverConsent;
    if (isShopify || privatePage || !endpoint) return;
    if (explicit) {
      choiceVersion++;
      if (!state.analytics || !state.marketing) {
        pendingMemory = { id: Date.now() + ':' + (++pendingCounter) + ':' + Math.random().toString(16).slice(2),
          analytics: state.analytics, marketing: state.marketing, saved: Date.now() };
        write(serverPendingKey, pendingMemory);
      } else clearPending(); // Only a new explicit all-purpose grant supersedes a pending denial.
    }
    const pending = pendingDenial();
    const version = choiceVersion;
    const requested = { ...state };
    const affectsUI = explicit || Boolean(pending);
    if (affectsUI) { serverStatus('Preferences saved on this device. Waiting for server confirmation.'); show(true); }
    const failed = () => {
      if (version === choiceVersion && (explicit || (pending && pendingDenial()?.id === pending.id))) {
        serverStatus(pending
          ? 'Preferences are saved on this device, but server withdrawal is not confirmed. A queued purchase may still be sent. Reload this page to retry, or contact support.'
          : 'Preferences are saved on this device, but server consent could not be confirmed. Reload this page to retry.');
        show(true);
      }
      return false;
    };
    let url;
    try { url = new URL(endpoint.url, location.href); } catch (_) { return Promise.resolve(failed()); }
    if (url.origin !== location.origin || !endpoint.nonce || typeof window.fetch !== 'function') return Promise.resolve(failed());
    const fields = new URLSearchParams({ action: 'df_analytics_consent', nonce: endpoint.nonce,
      analytics: state.analytics ? '1' : '0', marketing: state.marketing ? '1' : '0',
      gpc: navigator.globalPrivacyControl ? '1' : '0', explicit: explicit ? '1' : '0' });
    if (state.analytics && !sensitivePage && gaId === endpoint.ga4 && /^[0-9]{1,20}\.[0-9]{1,20}$/.test(clientId)) {
      fields.set('client_id', clientId); fields.set('measurement_id', gaId);
    }
    // Only an actual consented Google client ID may supplement the receipt.
    // No order IDs, purchase payload, email, URL or provider secret is accepted.
    const body = fields.toString();
    // Preserve choice order and wait for an initial HttpOnly receipt before updating it.
    consentQueue = consentQueue.catch(() => {}).then(async () => {
      const response = await window.fetch(url.href, { method: 'POST', credentials: 'same-origin', keepalive: true, referrerPolicy: 'no-referrer',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'X-DF-Consent': '1' }, body });
      if (!response?.ok) throw new Error('unconfirmed');
      const result = await response.json();
      if (result?.success !== true || typeof result.data?.analytics !== 'boolean' || typeof result.data?.marketing !== 'boolean'
        || (!requested.analytics && result.data.analytics) || (!requested.marketing && result.data.marketing)) throw new Error('unconfirmed');
      if (pending) clearPending(pending.id);
      if (affectsUI && version === choiceVersion && !pendingDenial()) { serverStatus(''); show(false); }
      return true;
    }).catch(failed);
    return consentQueue;
  }
  function retryPendingDenial() {
    const pending = pendingDenial();
    if (!pending || retryInFlight) return;
    state = { analytics: state.analytics && pending.analytics, marketing: state.marketing && pending.marketing };
    write(storageKey, { ...state, saved: Date.now() }); configure();
    const retry = persistServerConsent(false);
    if (retry) { retryInFlight = true; retry.finally(() => { retryInFlight = false; }); }
  }
  if (!isShopify) {
    window.addEventListener?.('online', retryPendingDenial);
    window.addEventListener?.('storage', event => { if (event.key === serverPendingKey) { pendingMemory = null; retryPendingDenial(); } });
  }
  function captureGoogleClient() {
    if (isShopify || sensitivePage || !state.analytics || !gaId || config.serverConsent?.ga4 !== gaId) return;
    // The genuine tag must supply its ID. A blocked/absent tag means no ID and
    // no server Purchase; never synthesize a client, session or engagement time.
    gtag('get', gaId, 'client_id', clientId => {
      if (state.analytics && !sensitivePage) persistServerConsent(false, clientId);
    });
  }
  function choose(analytics, marketing) {
    if (isShopify) {
      if (!ready) {
        const error = banner?.querySelector('[data-df-consent-status]');
        if (error) error.textContent = 'Preferences are unavailable. Optional tracking remains off. Try again shortly.';
        return;
      }
      window.Shopify.customerPrivacy.setTrackingConsent({ analytics, marketing, preferences: false,
        sale_of_data: marketing && !navigator.globalPrivacyControl }, () => { syncShopify(); show(false); });
    } else {
      state = { analytics, marketing: marketing && !navigator.globalPrivacyControl };
      chosen = true;
      write(storageKey, { ...state, saved: Date.now() });
      const saving = persistServerConsent(true);
      configure(); initialEvents(); if (!saving) show(false);
    }
  }
  document.addEventListener('click', e => {
    const choice = e.target.closest('[data-df-consent-choice]');
    if (choice) {
      if (choice.dataset.dfConsentChoice === 'save') {
        choose(Boolean(banner.querySelector('[name="df-analytics-consent"]')?.checked), Boolean(banner.querySelector('[name="df-marketing-consent"]')?.checked));
      } else choose(choice.dataset.dfConsentChoice === 'all', choice.dataset.dfConsentChoice === 'all');
    }
    if (e.target.closest('[data-df-consent-open]')) {
      if (banner) {
        banner.querySelector('[name="df-analytics-consent"]').checked = state.analytics;
        banner.querySelector('[name="df-marketing-consent"]').checked = state.marketing;
      }
      show(true); banner?.querySelector('button')?.focus();
    }
    const checkout = e.target.closest('[data-df-checkout],a[href$="/checkout"],button[name="checkout"]');
    if (checkout && config.platform !== 'woocommerce') track('begin_checkout');
  });
  document.addEventListener('df:cart-updated', event => {
    const { cart, previousCart, action } = event.detail || {};
    if (action !== 'add' || !previousCart || !cart) return;
    // Discounts can rotate Shopify line keys even when an existing item did not change.
    const identity = item => JSON.stringify([String(item.variant_id || item.id),
      String(item.selling_plan_allocation?.selling_plan?.id || ''),
      Object.entries(item.properties || {}).sort(([a], [b]) => a.localeCompare(b))]);
    const previousQuantities = new Map();
    previousCart.items.forEach(item => previousQuantities.set(identity(item), (previousQuantities.get(identity(item)) || 0) + item.quantity));
    const additions = cart.items.flatMap(item => {
      const key = identity(item);
      const previous = previousQuantities.get(key) || 0;
      const quantity = item.quantity - previous;
      previousQuantities.set(key, Math.max(0, previous - item.quantity));
      return quantity > 0 ? [{ item_id: String(item.variant_id), item_name: item.product_title || item.title, quantity }] : [];
    });
    // Native Shopify cart money has currency-specific subunit conventions; never guess a decimal divisor.
    if (additions.length) track('add_to_cart', { currency: cart.currency, items: additions });
  });
  if (window.jQuery && config.platform === 'woocommerce') {
    window.jQuery(document.body).on('added_to_cart', (_event, _fragments, _hash, button) => {
      track('add_to_cart', { currency: config.currency, items: [{ item_id: String(button?.data('product_id') || ''), quantity: Number(button?.data('quantity') || 1) }] });
    });
  }
  window.DFAnalytics = { track, consent: () => ({ ...state }), openPreferences: () => show(true) };
  if (isShopify) {
    document.addEventListener('visitorConsentCollected', syncShopify);
    if (window.Shopify?.customerPrivacy) syncShopify();
    else window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.2' }], error => { if (!error) syncShopify(); });
  } else {
    const saved = read(storageKey);
    if (saved && saved.saved > Date.now() - expiry) {
      state = { analytics: saved.analytics === true, marketing: saved.marketing === true && !navigator.globalPrivacyControl };
      chosen = true;
    }
    const pending = pendingDenial();
    if (pending) state = { analytics: state.analytics && pending.analytics, marketing: state.marketing && pending.marketing };
    persistServerConsent(false);
    configure(); initialEvents(); show(Boolean(pending) || (!chosen && Boolean(gaId || metaId || config.serverConsent?.active)));
  }
})();
